/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { styled } from "styled-components";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";
import Pagination from "../../../../components/Layout/Pagination/index";

const MainContainer = styled.div`
  // padding: 0 100px 60px 100px;
`;
function GenericTable({ data, tableData, headers, onPageChange }) {
  const [currentPage, setCurrentPage] = useState(0);
  const handleChangePage = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
    onPageChange(selectedPage.selected);
  };
  const pageCount = data.totalPages;
  // const EllipsisCell = styled(TableCell)`
  //   && {
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //     max-width: 200px;
  //   }
  // `;
  const EllipsisCell = styled(TableCell)`
    && {
      white-space: nowrap;
      overflow: hidden;
      max-width: 75px;
    }

    .ellipsis-content {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      line-height: 1.2em;
      max-height: 3.6em;
      font-size: 11px;
      font-weight: 400;
      min-width: 75px;
    }
  `;
  return (
    <MainContainer>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow
              style={{
                background:
                  "linear-gradient(180deg, #2A93C1 0%, #1D7196 87.50%, #BCD4DE 100%)",
              }}
            >
              {headers.map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    // fontWeight: "bold",
                    color: "white",
                    padding: "10px",
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow
                key={row.id}
                sx={{ background: index % 2 === 1 ? "#E8F6FC" : "#ffffff" }}
              >
                {headers.map((header) => (
                  <EllipsisCell
                    key={header}
                    sx={{
                      borderBottom:
                        index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                      borderTop:
                        index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                      textAlign: "center",
                    }}
                  >
                    {header === "Action" || "Actions" ? (
                      <div className="ellipsis-content">{row[header]}</div>
                    ) : (
                      <Tooltip title={row[header]}>
                        <div className="ellipsis-content">{row[header]}</div>
                      </Tooltip>
                    )}
                    {/* <Tooltip title={row[header]}>
                      <div className="ellipsis-content">{row[header]}</div>
                    </Tooltip> */}
                  </EllipsisCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        pageCount={pageCount}
        onPageChange={handleChangePage}
        forcePage={currentPage}
      />
    </MainContainer>
  );
}
export default GenericTable;
